import { connect } from 'react-redux';

const mapStateToProps = state => ({
  isLoggedIn: !!state.auth.uid
});

export default connect(mapStateToProps);



// WEBPACK FOOTER //
// ./src/components/app/enhance.js